import { render, staticRenderFns } from "./RoleUserManage2.vue?vue&type=template&id=186c7567"
import script from "./RoleUserManage2.vue?vue&type=script&lang=js"
export * from "./RoleUserManage2.vue?vue&type=script&lang=js"
import style0 from "./RoleUserManage2.vue?vue&type=style&index=0&id=186c7567&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports